import React, { useState } from "react";
import { Box, Card, CardContent, TextField, Button, Typography, Alert, CircularProgress } from "@mui/material";
import { observer } from "mobx-react-lite";
import { authStore } from "../stores/authStore";

const LoginForm: React.FC = observer(() => {
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await authStore.login({ login, password });
        } catch (error) {
            // Ошибка уже обработана в store
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                backgroundColor: "background.default",
            }}
        >
            <Card sx={{ maxWidth: 400, width: "100%", mx: 2 }}>
                <CardContent sx={{ p: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom align="center">
                        Вход в систему
                    </Typography>

                    <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
                        Личный кабинет поставщика
                    </Typography>

                    {authStore.error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {authStore.error}
                        </Alert>
                    )}

                    <Box component="form" onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Логин"
                            value={login}
                            onChange={(e) => setLogin(e.target.value)}
                            margin="normal"
                            required
                            disabled={authStore.loading}
                        />

                        <TextField
                            fullWidth
                            label="Пароль"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            margin="normal"
                            required
                            disabled={authStore.loading}
                        />

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            disabled={authStore.loading || !login || !password}
                        >
                            {authStore.loading ? <CircularProgress size={24} color="inherit" /> : "Войти"}
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
});

export default LoginForm;
